/* UMOJA cart drawer: opens on add to cart or on the header Cart link, edits lines through the cart API, suggests similar pieces in stock. */
(function(){
  const root = document.getElementById('ucart');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const cfg = JSON.parse(document.getElementById('ucartCfg').textContent);
  const $ = sel => root.querySelector(sel);
  const list = $('[data-ucart-items]'), empty = $('[data-ucart-empty]'), foot = $('[data-ucart-footer]'), recsBox = $('[data-ucart-recs]'), msg = $('[data-ucart-msg]'), note = $('[data-ucart-note]');
  const panel = $('.panel');
  const nativeFetch = window.fetch.bind(window);
  const api = (url, body) => nativeFetch(cfg.root + url.replace(/^\//, ''), body ? {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(body)} : {headers:{Accept:'application/json'}}).then(r => r.json().then(j => { if (!r.ok) throw j; return j; }));
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = cents => {
    const n = (cents/100), fmt = cfg.money || '${{amount}}';
    const group = (v, d, th, dec) => { const [a, b] = v.toFixed(d).split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (b ? dec + b : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => k === 'amount_no_decimals' ? group(n, 0, ',', '.') : k === 'amount_with_comma_separator' ? group(n, 2, '.', ',') : k === 'amount_no_decimals_with_comma_separator' ? group(n, 0, '.', ',') : group(n, 2, ',', '.')).replace(/<[^>]*>/g, '');
  };
  const short = s => String(s || '').split(' - ')[0].split(' — ')[0];
  const img = (src, w) => src ? src.replace(/^\/\//, 'https://') + (src.includes('?') ? '&' : '?') + 'width=' + w : '';
  let cart = null, lastFocus = null, busy = false;

  const counters = () => document.querySelectorAll('[data-cart-count]');
  function render(){
    const items = cart.items;
    counters().forEach(el => el.textContent = cart.item_count);
    $('[data-ucart-count]').textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    empty.hidden = items.length > 0;
    foot.hidden = items.length === 0;
    list.innerHTML = items.map((it, i) => `
      <li class="line">
        <a class="ph" href="${esc(it.url)}">${it.image ? `<img src="${esc(img(it.image, 240))}" alt="${esc(it.product_title)}" loading="lazy">` : ''}</a>
        <div class="info">
          <a class="nm" href="${esc(it.url)}">${esc(short(it.product_title))}</a>
          ${it.product_has_only_default_variant ? '' : `<span class="v">${esc(it.variant_title)}</span>`}
          <div class="ctl">
            <div class="qty" aria-label="Quantity"><button type="button" data-q="${i+1}" data-to="${it.quantity-1}" aria-label="Decrease">&minus;</button><span>${it.quantity}</span><button type="button" data-q="${i+1}" data-to="${it.quantity+1}" aria-label="Increase">+</button></div>
            <button type="button" class="rm" data-q="${i+1}" data-to="0">Remove</button>
          </div>
        </div>
        <span class="pr">${money(it.final_line_price)}</span>
      </li>`).join('');
    $('[data-ucart-subtotal]').textContent = money(cart.total_price);
    if (note && document.activeElement !== note) note.value = cart.note || '';
  }

  async function refresh(){ cart = await api('/cart.js'); render(); recs(); }

  async function change(line, quantity){
    if (busy) return; busy = true; msg.textContent = '';
    try { cart = await api('/cart/change.js', {line, quantity}); render(); recs(); }
    catch(e){ msg.textContent = e.description || e.message || 'Something went wrong.'; await refresh(); }
    busy = false;
  }

  /* suggestions: same series in stock, then Shopify related pieces in stock, then the fallback collection */
  let recsFor = null;
  async function recs(){
    if (!recsBox || !cfg.recs) return;
    const first = cart.items[0];
    if (!first){ recsBox.hidden = true; recsFor = null; return; }
    const inCart = new Set(cart.items.map(i => i.product_id));
    const key = first.product_id + ':' + [...inCart].join(',');
    if (key === recsFor) return; recsFor = key;
    let out = [];
    const add = arr => { for (const p of arr){ if (p && !inCart.has(p.id) && !out.some(o => o.id === p.id)) out.push(p); if (out.length >= cfg.recsCount) break; } };
    try {
      const html = await nativeFetch(cfg.root + 'products/' + first.handle + '?section_id=umoja-cart-recs').then(r => r.text());
      const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs]');
      if (node) add(JSON.parse(node.textContent));
    } catch(e){}
    if (out.length < cfg.recsCount) try {
      const r = await api('/recommendations/products.json?product_id=' + first.product_id + '&limit=10&intent=related');
      add(r.products.filter(p => p.available).map(p => ({id:p.id, title:p.title, url:p.url, price:p.price, image:p.featured_image, variant:(p.variants.find(v => v.available) || {}).id})));
    } catch(e){}
    if (out.length < cfg.recsCount && cfg.fallback) try {
      const r = await api('/collections/' + cfg.fallback + '/products.json?limit=30');
      add(r.products.map(p => { const v = p.variants.find(x => x.available); return v ? {id:p.id, title:p.title, url:cfg.root + 'products/' + p.handle, price:Math.round(parseFloat(v.price)*100), image:(p.images[0] || {}).src, variant:v.id} : null; }));
    } catch(e){}
    out = out.filter(p => p.variant);
    recsBox.hidden = !out.length;
    recsBox.querySelector('ul').innerHTML = out.map(p => `
      <li><a class="ph" href="${esc(p.url)}">${p.image ? `<img src="${esc(img(p.image, 300))}" alt="${esc(p.title)}" loading="lazy">` : ''}</a>
      <a class="nm" href="${esc(p.url)}">${esc(short(p.title))}</a><span class="pr">${money(p.price)}</span>
      <button type="button" class="add" data-add="${p.variant}">Add</button></li>`).join('');
  }

  function open(){
    if (root.classList.contains('open')) return;
    lastFocus = document.activeElement;
    root.classList.add('open'); root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ucart-lock');
    setTimeout(() => panel.focus(), 60);
  }
  function close(){
    root.classList.remove('open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ucart-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.UmojaCart = {open, close, refresh};

  root.addEventListener('click', e => {
    const t = e.target.closest('button, [data-ucart-close]');
    if (!t) return;
    if (t.hasAttribute('data-ucart-close')) return close();
    if (t.dataset.q) return change(+t.dataset.q, Math.max(0, +t.dataset.to));
    if (t.dataset.add){ t.disabled = true; t.textContent = 'Adding'; api('/cart/add.js', {items:[{id:+t.dataset.add, quantity:1}]}).then(refresh).catch(err => { msg.textContent = err.description || 'This piece is no longer available.'; t.disabled = false; t.textContent = 'Add'; }); }
  });
  addEventListener('keydown', e => { if (e.key === 'Escape' && root.classList.contains('open')) close(); });

  if (note){ let tm; note.addEventListener('input', () => { clearTimeout(tm); tm = setTimeout(() => api('/cart/update.js', {note:note.value}), 500); }); }
  $('[data-ucart-checkout]').addEventListener('click', async e => { if (!note) return; e.preventDefault(); const href = e.currentTarget.href; try { await api('/cart/update.js', {note:note.value}); } catch(x){} location.href = href; });

  /* the header Cart link opens the drawer */
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-cart-open]');
    if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault(); open(); refresh();
  });

  /* any add to cart made by the theme opens the drawer */
  window.fetch = function(input, init){
    const url = String(input instanceof Request ? input.url : input || '');
    const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    const p = nativeFetch(input, init);
    if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url)) p.then(r => { if (r.ok){ refresh(); open(); } }).catch(() => {});
    return p;
  };

  refresh().catch(() => {});
})();
